import { useAppSelector } from 'hooks';

import { Features, FeatureStatusType } from 'models/user.types';

/**
 * Returns true when the requested feature has the expected status in the current user slice.
 *
 * @param feature - The feature key to inspect on the user object.
 * @param status - Optional status to compare with the current feature status.
 * @returns True when the feature status matches the provided status value.
 */
export const useSelectFeatureStatus = (
  feature: keyof Features,
  status: FeatureStatusType = 'disabled'
) => {
  return useAppSelector((state) => state?.user?.features?.[feature]?.status === status);
};
